module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av52-f14d5d97e953ebd92e0210e5e0b85393.jpg";